export default "__VITE_ASSET__DbvDdgOV__"